import React from "react";
import { useSearchParams } from "react-router-dom";
import T from "../styles/tokens";
import { PFLogo } from "../components/UI";

export default function ErrorPage() {
  const [params] = useSearchParams();
  const message = params.get("message") || "An unexpected error occurred.";

  return (
    <div style={{ minHeight: "100vh", background: `linear-gradient(160deg, ${T.indigo} 0%, ${T.purple} 50%, ${T.indigo} 100%)`, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ maxWidth: 480, margin: "0 auto", padding: "40px 24px", textAlign: "center" }}>
        <div style={{ display: "inline-flex", alignItems: "center", gap: 12, marginBottom: 36 }}>
          <PFLogo size={36} />
          <span style={{ color: T.white, fontSize: 16, fontWeight: 700, fontFamily: T.font }}>Pathfinder Technical Services</span>
        </div>

        <div style={{ background: T.white, borderRadius: 16, boxShadow: T.shadowLg, padding: 40 }}>
          <div style={{ width: 64, height: 64, borderRadius: "50%", background: T.redBg, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px", color: T.red, fontSize: 28 }}>✕</div>
          <h1 style={{ fontSize: 22, fontWeight: 700, color: T.indigo, fontFamily: T.font, margin: "0 0 10px" }}>Something Went Wrong</h1>
          <p style={{ fontSize: 14, color: T.charcoal, fontFamily: T.font, lineHeight: 1.6, marginBottom: 24 }}>{message}</p>
          <p style={{ fontSize: 13, color: T.gray400, fontFamily: T.font }}>
            Need help? Contact us at{" "}
            <a href="mailto:support@pathfindtech.com" style={{ color: T.purple, fontWeight: 600, textDecoration: "none" }}>support@pathfindtech.com</a>
          </p>
        </div>

        <p style={{ fontSize: 11.5, color: "rgba(255,255,255,0.35)", fontFamily: T.font, marginTop: 24 }}>
          You can close this window.
        </p>
      </div>
    </div>
  );
}
